export interface Partner {
  name: string
  logo: string
}

export const partners: Partner[] = [
  { name: 'CAME', logo: '/media/partners/came-logo.svg' },
  { name: 'FAAC', logo: '/media/partners/faac-logo.svg' },
  { name: 'Siemens', logo: '/media/partners/siemens-logo.svg' },
  { name: 'SKIDATA', logo: '/media/partners/skidata-logo.png' },
  { name: 'Honeywell', logo: '/media/partners/honeywell-logo.svg' },
  { name: 'HUB', logo: '/media/partners/hub-logo.png' },
  { name: 'Fadini', logo: '/media/partners/fadini-logo.png' },
]

export interface Certification {
  name: string
  logo: string
  descriptionKey: string
  pdfUrl?: string
}

export const certifications: Certification[] = [
  {
    name: 'ISO 27001',
    logo: '/media/certifications/iso-27001-logo.png',
    descriptionKey: 'certifications.iso27001',
    pdfUrl: 'https://www.selea.com/wp-content/uploads/2025/07/ISO-IEC_27001-ITA-C692547-0-20250714-1.pdf',
  },
  {
    name: 'ISO 9001',
    logo: '/media/certifications/iso-9001-logo.png',
    descriptionKey: 'certifications.iso9001',
    pdfUrl: 'https://www.selea.com/wp-content/uploads/2025/07/Certificate-IT323778-SELEA-S.R.L-ISO9001-REV1.pdf',
  },
  {
    name: 'NDAA Conformity',
    logo: '/media/certifications/ndaa-conformity-logo.png',
    descriptionKey: 'certifications.ndaa',
    pdfUrl: 'https://www.selea.com/wp-content/uploads/2025/07/doc-di-Conformita-NDAA-1-1.pdf',
  },
  {
    name: 'ISDP 10003',
    logo: '/media/certifications/isdp-10003-privacy-by-design-logo.png',
    descriptionKey: 'certifications.isdp10003',
    pdfUrl: 'https://www.selea.com/wp-content/uploads/2025/11/ISDP10003_IT_2024.pdf',
  },
  {
    name: 'UNI 10772',
    logo: '/media/certifications/uni-10772-logo.png',
    descriptionKey: 'certifications.uni10772',
  },
]
